import React from 'react';

import { ApiUrl} from '../../../project/Defines';

import ListView from '../../../Shared/ListView';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { EVENT_NAME } from '../../../project/utilities';
import { PopupClasses, PopupTypes } from '../../../components/Popup';

export default function ThercodimVersion() {
    const columns = [
        {
            text: 'text.version',
            field: 'number',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.comments',
            field: 'comment',
            render: (text, record) => {
                const _text = text.indexOf('\n') < 0 ? text : text.slice(0, text.indexOf('\n'));
                return <wrap>
                    <text>{_text}</text>
                </wrap>
            },
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION
        }
        
    ];

    return (
        <div className="form_container">
            <ListView
                columnConfig={columns}
                // dataSource={[]}
                apiUrl={ApiUrl.ThercodimVersionList}
                deleteUrl={ApiUrl.ThercodimVersionDelete}
                //detailUrl={Project.getPageUrl(AppPages.ThercodimVersionDetails)}
                detailProps={{ fullScreen: false, popupType: PopupTypes.ThercodimVersion, className: PopupClasses.Medium, windowKey: 'wndThercodimVersionDetail' }}
                listUpdateEvent={EVENT_NAME.THERCODIM_VERSION_LIST_UPDATE}
                nameField='number'
               
            />
        </div>
    );
}
